import { useState } from 'react';
import {useDebounce} from "@uidotdev/usehooks";
import useDidMountEffect from "./useDidMountEffect";
import {useDefaultQuoteSettingsContext} from "../contexts/DefaultQuoteSettingsContext";

const useDefaultFeeStateHook = (fee) => {
    const { quoteSettings, setSettingsStateWithUpdate, updateQuoteSettingsResponse } = useDefaultQuoteSettingsContext()
    const [feeState, setFeeState] = useState(fee)

    const debouncedFeeState = useDebounce(feeState, 300)

    const setFeeStateWithUpdate = (newState, updateFeeState = true, updateBackend = true) => {
        return setFeeState({...feeState, ...newState, _update: updateFeeState, _updateBackend: updateBackend})
    }

    useDidMountEffect(function updateFeeFromBackend(){
        setFeeState({...fee, _update: false})
    }, [])

    useDidMountEffect(function updateFeeInBackend(){
        if (feeState && feeState._update === true) {
            let newQuoteSettings = structuredClone(quoteSettings)
            let allFees = newQuoteSettings.fees

            allFees.forEach((el, index, array) => {
                if (feeState.id === el.id) {
                    array[index] = feeState
                }
            })

            newQuoteSettings.fees = allFees
            setSettingsStateWithUpdate(newQuoteSettings, feeState._updateBackend)
        }
    }, [debouncedFeeState])

    useDidMountEffect(function updateFeeFromBackend(){
        if (
            updateQuoteSettingsResponse?.data?.data &&
            !updateQuoteSettingsResponse.loading &&
            !updateQuoteSettingsResponse.error &&
            feeState
        ) {
            const newQuoteSettingsState = updateQuoteSettingsResponse?.data?.data

            const feeFromBackend = newQuoteSettingsState.fees.find(f => String(f.id) === String(feeState.id))

            if (feeFromBackend) {
                setFeeStateWithUpdate(feeFromBackend, false)
            }
        }
    }, [updateQuoteSettingsResponse])


    return [feeState, setFeeStateWithUpdate]
}

export default useDefaultFeeStateHook;